import { Button, Group, Modal, Text } from '@mantine/core';
import { useIntl } from 'react-intl';

interface DeleteFolderModalProps {
  opened: boolean;
  onClose: () => void;
  folderName: string;
  fileCount: number;
  onConfirm: () => void;
}

export const DeleteFolderModal = ({
  opened,
  onClose,
  folderName,
  fileCount,
  onConfirm,
}: DeleteFolderModalProps) => {
  const intl = useIntl();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`${intl.formatMessage({ id: 'delete' })} ${intl.formatMessage({ id: 'folder' }).toLowerCase()}`}
      centered
    >
      <Text size="sm">
        {intl.formatMessage({ id: 'areYouSureYouWantToDelete' })}{' '}
        <strong>{folderName}</strong>?
      </Text>

      {fileCount > 0 && (
        <Text size="sm" c="orange" mt="xs" fw={500}>
          {intl.formatMessage(
            { id: 'folderContainsFiles' },
            { count: fileCount }
          )}
          .
        </Text>
      )}

      <Text size="sm" c="red" mt="xs" fw={500}>
        {intl.formatMessage({ id: 'thisActionIsIrreversible' })}.
      </Text>

      <Group justify="flex-end" mt="md">
        <Button variant="subtle" onClick={onClose}>
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button color="red" onClick={handleConfirm}>
          {intl.formatMessage({ id: 'delete' })}
        </Button>
      </Group>
    </Modal>
  );
};
